/* eslint-disable no-console */
const merchantsList = new Map([
  [49, 'Wayfair.com'],
  [81, 'Allmodern.com'],
  [450, 'Jossandmain.com'],
  [422, 'Birchlane.com'],
]);

const getFromStorage = param => {
  try {
    return localStorage.getItem(param);
  } catch (error) {
    console.log(error);
    return null;
  }
};

// Retailer fields the in-store flow learns from /instore/location/. Kept in memory rather than localStorage: the
// values come from a server response, and the app re-runs that lookup from the URL on every load anyway.
let retailerContext = {};

export const setRetailerContext = context => {
  retailerContext = { ...retailerContext, ...context };
};

export const segmentEvent = (type, event, additional, sessionId = null, merchant = 49) => {
  if (window.analytics) {
    const defaultRetailerName = merchantsList.get(Number.parseInt(merchant, 10));
    const payload = {
      retailer_name: retailerContext.retailerName || getFromStorage('retailerName') || defaultRetailerName,
      retailer_id: retailerContext.retailerId || getFromStorage('retailerId') || null,
      available_limit: getFromStorage('availableLimit') || '0',
      ...additional,
    };
    const integration = {
      integrations: {
        Amplitude: {
          session_id: sessionId || getFromStorage('sessionId'),
        },
      },
    };

    if (type === 'identify') {
      try {
        // eslint-disable-next-line no-undef
        analytics.identify(event, payload, integration);
        localStorage.setItem('sessionId', sessionId);
        console.log(`---- Segment IDENTIFY. Name: ${event} ----------------`);
      } catch (error) {
        console.log(`---- ERROR. Segment IDENTIFY. Name: ${event} ----------------`);
        console.log(error);
      }
    } else if (type === 'page') {
      try {
        console.log(`---- Segment PAGE. Name: ${event} ----------------`);
        // eslint-disable-next-line no-undef
        analytics.page(event, payload, integration);
      } catch (error) {
        console.log(`---- ERROR. Segment PAGE. Name: ${event} ----------------`);
        console.log(error);
      }
    } else {
      try {
        // eslint-disable-next-line no-undef
        analytics.track(event, payload, integration);
        console.log(`---- Segment TRACK. Name: ${event} ----------------`);
      } catch (error) {
        console.log(`---- ERROR. Segment TRACK. Name: ${event} ----------------`);
        console.log(error);
      }
    }
    console.log('Payload', payload);
    console.log('Integration', integration);
    console.log('-----------------------------');
  }
};
